import { fetcher_default } from "./chunk-GONJSORR.mjs";
import { __export } from "./chunk-QK4PKNB3.mjs"; // src/services/profile.ts

var profile_exports = {};

__export(profile_exports, {
  batchUpdateData: function batchUpdateData() {
    return _batchUpdateData;
  },
  getBodyData: function getBodyData() {
    return _getBodyData;
  },
  getGroupClassSummary: function getGroupClassSummary() {
    return _getGroupClassSummary;
  },
  getGroupClassSummaryByID: function getGroupClassSummaryByID() {
    return _getGroupClassSummaryByID;
  },
  getMoveData: function getMoveData() {
    return _getMoveData;
  },
  getNutrition: function getNutrition() {
    return _getNutrition;
  },
  getSleepData: function getSleepData() {
    return _getSleepData;
  },
  getSummary: function getSummary() {
    return _getSummary;
  },
  removeData: function removeData() {
    return _removeData;
  }
});

var _getGroupClassSummary = function _getGroupClassSummary(param) {
  return fetcher_default.get("/v4/consulting/group_class_summaries", param);
};

var _getGroupClassSummaryByID = function _getGroupClassSummaryByID(id, param) {
  return fetcher_default.get("/v4/consulting/group_class_summaries/".concat(id), param);
};

var _getSummary = function _getSummary(param) {
  return fetcher_default.get("/v4/summaries/between_dates", param);
};

var _getBodyData = function _getBodyData(param) {
  return fetcher_default.get("/v4/summaries", param);
};

var _getNutrition = function _getNutrition(param) {
  return fetcher_default.get("/v4/nutrition_summaries", param);
};

var _getMoveData = function _getMoveData(param) {
  return fetcher_default.get("/v4/move_summaries", param);
};

var _getSleepData = function _getSleepData(param) {
  return fetcher_default.get("/v4/sleep_summaries", param);
};

var _removeData = function _removeData(param) {
  return fetcher_default.put("/v4/summaries/update_by_date", param);
};

var _batchUpdateData = function _batchUpdateData(param) {
  return fetcher_default.put("/v4/summaries/batch_update_by_date", {
    summaries: param
  });
};

export { _getGroupClassSummary as getGroupClassSummary, _getGroupClassSummaryByID as getGroupClassSummaryByID, _getSummary as getSummary, _getBodyData as getBodyData, _getNutrition as getNutrition, _getMoveData as getMoveData, _getSleepData as getSleepData, _removeData as removeData, _batchUpdateData as batchUpdateData, profile_exports };